"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    title: {
        fontSize: 11,
        textTransform: 'uppercase',
        fontWeight: 600,
        letterSpacing: 1,
        color: theme.grey1,
        marginBottom: 7
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 14,
        marginBottom: 3
    },
    input: {
        marginRight: 10,
        width: 15,
        height: 15,
        cursor: 'pointer'
    },
    inputChecked: {
        color: theme.indigo3
    }
});
//# sourceMappingURL=inputCollection.style.js.map